import React, {
  ReactElement,
  useState,
} from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import TFAForm from '../../forms/Register/NewTFAFlow/TFAForm';

interface Props {
  showModal: boolean;
  phoneNumber: string;
}

const SecondFactorAuthModal: React.FC<Props> = ({ showModal = false, phoneNumber }): ReactElement => {
  const [show, setShow] = useState(showModal);

  const handleClose = () => setShow(false);

  return (
    <div className="text-center">
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-sm"
        backdropClassName="bg-blue-200"
        scrollable={true}
      >
        <Modal.Body className="p-0">
          {show && (
            <div className="tfa-form">
              <TFAForm onClose={handleClose} phoneNumber={phoneNumber} />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SecondFactorAuthModal;

if (document.getElementById('react-second-factor-auth-modal')) {
  const element = document.getElementById('react-second-factor-auth-modal');
  const showModalAttribute = element?.dataset.showModal ?? 'false';
  const phoneNumber = element?.dataset.phoneNumber ?? '';
  const showModal = Boolean(JSON.parse(showModalAttribute));
  ReactDOM.render(
    <SecondFactorAuthModal showModal={showModal} phoneNumber={phoneNumber} />,
    element,
  );
}
